/**
 * Meal Tabs Section JavaScript
 * Handles tab switching and "Add All" functionality
 */
(function() {
  'use strict';

  // Guard against multiple initializations
  if (window.MealTabsInitialized) return;
  window.MealTabsInitialized = true;

  // Helper to get base URL safely
  function getBaseUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  // Update quantity inputs on product cards after cart changes
  function updateProductCardQuantities(cart) {
    if (!cart || !cart.items) return;

    document.querySelectorAll('quick-add-bulk').forEach(quickAdd => {
      const variantId = quickAdd.dataset.index;
      if (!variantId) return;

      let quantityInCart = 0;
      cart.items.forEach(item => {
        const id = String(item.variant_id || item.id);
        if (id === String(variantId)) quantityInCart += item.quantity;
      });

      applyQuantityToStepper(quickAdd, quantityInCart);
    });
  }

  function applyQuantityToStepper(quickAdd, quantityInCart) {
    const input = quickAdd.querySelector('.quantity__input, input[data-quantity-variant-id]');
    if (input) {
      input.value = quantityInCart;
      input.setAttribute('value', quantityInCart);
      input.dataset.cartQuantity = String(quantityInCart);
    }

    const quantityInput = quickAdd.querySelector('quantity-input');
    if (quantityInput) {
      if (quantityInCart > 0) {
        quantityInput.classList.add('quantity--has-items');
      } else {
        quantityInput.classList.remove('quantity--has-items');
      }
    }

    const minusBtn = quickAdd.querySelector('.quantity__button[name="minus"]');
    if (minusBtn) {
      if (quantityInCart <= 0) {
        minusBtn.classList.add('disabled');
      } else {
        minusBtn.classList.remove('disabled');
      }
    }
  }

  // Initialize a meal tabs section
  function initMealTabsSection(section) {
    if (!section || section.dataset.mealTabsInitialized) return;
    section.dataset.mealTabsInitialized = 'true';

    const tabButtons = section.querySelectorAll('.meal-tabs__tab-button');
    const panes = section.querySelectorAll('.meal-tabs__pane');

    // TAB SWITCHING
    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;
        tabButtons.forEach(b => b.classList.toggle('is-active', b === btn));
        panes.forEach(p => p.classList.toggle('is-active', p.dataset.tab === tab));
      });
    });

    // ADD ALL BUTTONS
    section.querySelectorAll('.meal-tabs__add-all').forEach(button => {
      // Remove any existing listeners by cloning
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        // Prevent double-clicks
        if (newButton.disabled || newButton.classList.contains('is-loading')) {
          return;
        }

        const tab = newButton.dataset.tab;
        const pane = section.querySelector(`.meal-tabs__pane[data-tab="${tab}"]`);
        if (!pane) return;

        // Gather variant IDs from grid items (bundles add as their own product)
        const variantIds = new Set();
        pane.querySelectorAll('.grid__item[data-variant-id]').forEach(el => {
          const id = el.getAttribute('data-variant-id');
          if (id) variantIds.add(Number(id));
        });

        const items = Array.from(variantIds).map(id => ({
          id: id,
          quantity: 1
        }));

        if (!items.length) {
          console.error('No items found to add to cart.');
          return;
        }

        // LOADING UI
        newButton.classList.add('is-loading');
        newButton.disabled = true;

        // Prepare Fetch
        const baseUrl = getBaseUrl();
        const cleanBase = baseUrl === '/' ? '' : baseUrl.replace(/\/$/, '');
        const addUrl = `${cleanBase}/cart/add.js`;
        const cartUrl = `${cleanBase}/cart`;

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: items,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });

          if (!response.ok) {
            throw new Error('Failed to add items to cart');
          }

          const responseJson = await response.json();

          if (responseJson.errors) {
            throw new Error('One or more items could not be added.');
          }

          // Fetch updated cart data
          const cartResponse = await fetch('/cart.js', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
          });
          const cart = await cartResponse.json();

          // 1. UPDATE CART ICON
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble && responseJson.sections && responseJson.sections['cart-icon-bubble']) {
            cartIconBubble.innerHTML = responseJson.sections['cart-icon-bubble'];
          }

          // 2. UPDATE PRODUCT CARD QUANTITIES
          updateProductCardQuantities(cart);

          // 3. PUBLISH CART UPDATE EVENT for other components
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'meal-tabs',
              cartData: cart
            });
          }

          // 4. DISPATCH DOM EVENT
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));

          // 5. UPDATE & OPEN DRAWER
          const cartDrawer = document.querySelector('cart-drawer');
          // Only auto-open on large desktop (1920px+)
          const shouldAutoOpen = window.innerWidth >= 1920;
          console.log('[CartDrawer Debug] meal-tabs: shouldAutoOpen:', shouldAutoOpen, 'viewport:', window.innerWidth);

          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');

            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(responseJson, shouldAutoOpen);
            } else if (responseJson.sections && responseJson.sections['cart-drawer']) {
              // Manual update if renderContents not available
              const html = new DOMParser().parseFromString(responseJson.sections['cart-drawer'], 'text/html');

              const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.drawer__header'];
              selectors.forEach(selector => {
                const source = html.querySelector(selector);
                const target = document.querySelector(selector);
                if (source && target) {
                  target.replaceWith(source.cloneNode(true));
                }
              });

              // Remove empty state
              const emptyDiv = document.querySelector('.drawer__inner-empty');
              if (emptyDiv && cart.item_count > 0) {
                emptyDiv.remove();
              }

              // Enable checkout button
              const checkoutBtn = document.querySelector('#CartDrawer-Checkout');
              if (checkoutBtn) {
                checkoutBtn.removeAttribute('disabled');
              }

              // Open drawer only on large desktop
              if (shouldAutoOpen) {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                } else {
                  cartDrawer.classList.add('active');
                  document.body.classList.add('overflow-hidden');
                }
              }
            }
          } else {
            // Fallback to cart page
            window.location.href = cartUrl;
          }

        } catch (error) {
          console.error('Error adding items to cart:', error);
        } finally {
          newButton.classList.remove('is-loading');
          newButton.disabled = false;
        }
      });
    });
  }

  // Initialize all meal tabs sections on page
  function initAllMealTabs() {
    document.querySelectorAll('[id^="meal-tabs-"]').forEach(initMealTabsSection);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMealTabs);
  } else {
    initAllMealTabs();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[id^="meal-tabs-"]');
    if (section) {
      section.removeAttribute('data-meal-tabs-initialized');
      initMealTabsSection(section);
    }
  });

  // Expose for manual initialization if needed
  window.initMealTabsSection = initMealTabsSection;
})();